module.exports = __webpack_public_path__ + "0a619fdee502bc5fd0f97bb54a226601.png";